import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TileSection } from 'foundations-components/transitional/components/Tile';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ConnectAppButton from './ConnectAppButton';
import isEmbedded from '../utils/isEmbedded';
import { isOnlyRequestingOAuthScope } from '../utils/urls';
import { getHasIntegrationsManagementWrite } from '../selectors/ScopeSelectors';
import { getEcosystemDetailsData } from '../selectors/EcosystemSelectors';
import { getIsRequestingNewScopes } from '../selectors/AppSelectors';
import Tracker from '../utils/usageTracker';
import { EVENTS } from '../constants/Events';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AuthorizeFooter() {
  const location = useLocation();
  const hasIntegrationsManagementWrite = useSelector(getHasIntegrationsManagementWrite);
  const isRequestingNewScopes = useSelector(getIsRequestingNewScopes);
  const hasNoInstallPermission = !hasIntegrationsManagementWrite && !isOnlyRequestingOAuthScope(location.search) && isRequestingNewScopes;
  const [termsConfirmed, setTermsConfirmed] = useState(false);
  const ecosystemDetails = useSelector(getEcosystemDetailsData);

  // Only disable the term checkbox if:
  // There are ecosystemDetails and the following conditions are met:
  // they do not have the integrations-management-write and the app has not been installed before and the app is requesting more than just the oauth scope
  const termsDisabled = !!(ecosystemDetails && (hasIntegrationsManagementWrite || isOnlyRequestingOAuthScope(location.search) || !isRequestingNewScopes));
  return /*#__PURE__*/_jsx(TileSection, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [ecosystemDetails && /*#__PURE__*/_jsxs(TFlex, {
        marginBlockEnd: "400",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: termsDisabled,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oauth.app.marketplaceAccess.toContinueNeedPermissionTooltip"
          }),
          children: /*#__PURE__*/_jsx(Checkbox, {
            alignment: "center",
            onChange: ({
              target: {
                checked
              }
            }) => setTermsConfirmed(checked),
            disabled: !termsDisabled,
            marginBlockEnd: "400"
          })
        }), /*#__PURE__*/_jsx(Small, {
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "oauth.app.termsAndPrivacy.body_jsx",
            elements: {
              Link
            },
            options: {
              privacyPolicyProps: {
                href: ecosystemDetails.privacyUrl,
                external: true
              },
              termLinkProps: {
                href: ecosystemDetails.termsUrl,
                external: true
              }
            }
          })
        })]
      }), /*#__PURE__*/_jsx(ConnectAppButton, {
        hasUnconfirmedTerms: !!ecosystemDetails && !termsConfirmed,
        hasNoInstallPermission: hasNoInstallPermission
      }), !isEmbedded && /*#__PURE__*/_jsx(Button, {
        href: "https://hubspot.com",
        onClick: () => {
          Tracker.track(EVENTS.INSTALL_FLOW_CANCELED);
        },
        marginInlineStart: "500",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "oauth.authorization.cancel"
        })
      })]
    })
  });
}
export default AuthorizeFooter;